module.exports = __webpack_public_path__ + "img/code_single.91d17a39.svg";